<!--
 * @Description: 
 * @Date: 2022-02-22 11:08:53
 * @LastEditTime: 2023-01-31 15:59:06
 * @FilePath: \admin_hilo\src\components\main\components\side-menu\side-menu-item.vue
-->
<template>
  <Submenu :name="`${parentName}`">
    <template slot="title">
      <common-icon :type="parentItem.icon || ''" />
      <span>{{ showTitle(parentItem) }}</span>
    </template>
    <template v-for="item in children">
      <template v-if="item.children && item.children.length == 1">
        <!-- <router-link :to="{ path: item.path }" :key="item.name"> -->
        <side-menu-item
          v-if="showChildren(item)"
          :key="`menu-${item.name}`"
          :parent-item="item"
        ></side-menu-item>
        <menu-item
          v-else
          :name="getNameOrHref(item, true)"
          :key="`menu-${item.children[0].name}`"
          ><common-icon :type="item.children[0].icon || ''" /><span>{{
            showTitle(item.children[0])
          }}</span></menu-item
        >
        <!-- </router-link> -->
      </template>
      <template v-else>
        <!-- <router-link :to="{ path: item.path }" :key="item.name"> -->
        <side-menu-item
          v-if="showChildren(item)"
          :key="`menu-${item.name}`"
          :parent-item="item"
        ></side-menu-item>
        <menu-item v-else :name="getNameOrHref(item)" :key="`menu-${item.name}`"
          ><common-icon :type="item.icon || ''" /><span>{{
            showTitle(item)
          }}</span></menu-item
        >
        <!-- </router-link> -->
      </template>
    </template>
  </Submenu>
</template>
<script>
import mixin from "./mixin";
import itemMixin from "./item-mixin";
export default {
  name: "SideMenuItem",
  mixins: [mixin, itemMixin]
};
</script>



// WEBPACK FOOTER //
// src/components/main/components/side-menu/side-menu-item.vue